export default function TrialCompleteScreen() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-white">
      {/* 背景装飾 */}
      <div
        className="pointer-events-none absolute top-0 right-0 hidden md:block"
        style={{
          width: '796.63px',
          height: '656.65px',
          background: '#A7DCFF',
          filter: 'blur(200px)',
          opacity: 0.3,
          transform: 'translate(30%, -20%)',
        }}
      />

      {/* 背景装飾（左上の青いグラデーション楕円 - SP版のみ） */}
      <div
        className="pointer-events-none absolute top-0 right-0 block md:hidden"
        style={{
          width: '400px',
          height: '400px',
          background: '#A7DCFF',
          filter: 'blur(100px)',
          opacity: 0.3,
          transform: 'translate(30%, -30%)',
        }}
      />

      {/* ヘッダー */}
      <header
        className="relative flex h-20 items-center bg-white px-8"
        style={{ boxShadow: '0px 0px 15px rgba(2, 98, 255, 0.2)' }}
      >
        <img src="/logo/agenthub.svg" alt="エージェントハブ" className="h-8" />
      </header>

      {/* メインコンテンツ */}
      <div className="relative mx-auto flex w-full max-w-[890px] flex-col items-center px-6 pt-[160px]">
        {/* アイコン + タイトル */}
        <div className="mb-xl flex items-center gap-xxs md:gap-3">
          <img
            src="/images/trial/check-circle.png"
            alt=""
            className="size-xxl shrink-0 md:size-[60px]"
          />
          <h1 className="text-heading-md text-black md:text-heading-xxl">
            無料トライアル申し込み完了
          </h1>
        </div>

        {/* 説明テキスト */}
        <div className="mb-[46px] text-center text-[11px] text-black md:text-body-md">
          トライアル版にお申し込みいただきありがとうございます。
          <br className="" />
          ご入力いただいたメールアドレス宛に、ログインURLをお送りいたしました。
          <br className="hidden md:block" />
          記載されたURLから、機能をお試しいただけます。
        </div>

        {/* サポート情報ボックス */}
        <div className="mb-[53px] w-full rounded-sm bg-[#F6F6F6] px-xxl py-lg text-center md:px-x3l md:py-xl">
          <p className="mb-1 text-[10px] text-black md:text-body-sm">
            ご不明点やお困りのことがございましたら、以下のサポート窓口までお気軽にお問い合わせください。
          </p>
          <p className="text-[10px] text-black md:text-body-sm">
            support@agenthub.jp (受付時間：平日10:00〜18:00)
          </p>
        </div>

        {/* サイトトップに戻るボタン */}
        <a
          href="https://agenthub.jp"
          className="inline-flex w-[264px] items-center justify-center rounded-full border-2 p-4 text-lg leading-[1.6] font-bold no-underline hover:no-underline focus:no-underline md:w-[451px] md:text-xl"
          style={{
            borderImage: 'linear-gradient(190deg, #ED72F8 0%, #005FFF 88%) 1',
            borderImageSlice: 1,
            borderRadius: '100px',
            border: '2px solid transparent',
            backgroundImage:
              'linear-gradient(white, white), linear-gradient(190deg, #ED72F8 0%, #005FFF 88%)',
            backgroundOrigin: 'border-box',
            backgroundClip: 'padding-box, border-box',
            color: 'transparent',
            WebkitBackgroundClip: 'padding-box, border-box',
          }}
        >
          <span
            style={{
              fontFamily: '"Zen Kaku Gothic New", "Noto Sans JP", sans-serif',
              background: 'linear-gradient(190deg, #ED72F8 0%, #005FFF 88%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            サイトトップに戻る
          </span>
        </a>
      </div>
    </div>
  );
}
